import Main from './Main'
import CategoriasVeiculares from './categorias-veiculares/routes'
import OrgaoApreensor from './orgao-apreensor/routes'
import Patios from './patios/routes'
import Reboque from './reboque/routes'
import Reboquista from './reboquista/routes'
import Contratos from './contratos/routes'
import ContaBancaria from './conta-bancaria/routes'
import Feriado from './feriado/routes'
import TiposRestricao from './tipo-restricao/routes'
import BancoNotificacao from './banco-notificacao/routes'
import GruposPermissao from './grupos-permissao/routes'
import EstadoLote from './estado-lote/routes'
import BemEquipamento from './bem-equipamento/routes'
import EmpresaReboque from './empresa-reboque/routes'
import chatMasterRoutes from './chat/routes'

export default [
  {
    path: '/configuracoes',
    component: Main,
    name: 'configuracoes',
    children: [
      ...CategoriasVeiculares,
      ...EstadoLote,
      ...OrgaoApreensor,
      ...CategoriasVeiculares,
      ...Patios,
      ...EmpresaReboque,
      ...Reboque,
      ...Reboquista,
      ...Contratos,
      ...ContaBancaria,
      ...Feriado,
      ...TiposRestricao,
      ...BancoNotificacao,
      ...GruposPermissao,
      ...BemEquipamento,
      ...chatMasterRoutes
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/routes.js